import { useContext } from 'react';

import LoggedInUserContext from '../../context/LoggedInUserContext/LoggedInUserContext';
import { useChallengeProductCreationEnabled } from '../../utils/postHog';

/**
 * Whether the current user can create challenge products through the dedicated
 * creation flow. CAMs always have access (via the user doc). The PostHog flag
 * opens it to additional users through a uid allowlist payload (empty array =
 * everyone), so rollout beyond CAMs is controlled without a code change. Single
 * source of truth for this gate so the create flow and the legacy convert action
 * stay in sync.
 */
const useCanCreateChallengeProduct = () => {
  const { userId, userDoc } = useContext(LoggedInUserContext);
  // Call the flag hook unconditionally (rules of hooks) before combining.
  const challengeCreationEnabled = useChallengeProductCreationEnabled(userId);
  return !!userDoc?.isCAM || challengeCreationEnabled;
};

export default useCanCreateChallengeProduct;
